import { FEATURES } from '/src/features/_global/constants';

export const NOTIFICATIONS_PERMISSIONS = {
  [FEATURES.NOTIFICATIONS]: ({ capabilities }) => ({
    navigate: capabilities?.notifications.permissions.nav,
    edit: capabilities?.notifications.permissions.edit,
  }),
};
